import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import MediaUploader from './MediaUploader';
import MediumItem from './MediumItem';
import axios from 'axios';
import { API, Helpers, Router } from '../Helpers';
import Pagination from 'rc-pagination';

export default class Media extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      media: props.data.media,
      search: "",
      error: null,
      currentPage: 1,
      router: Router(this.props.data.routes),
    }

    this.onFileUploaded = this.onFileUploaded.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  
  componentDidMount() {
    // this.loadMedia();
    // console.log(this.props.data.routes);
  }

  loadMedia(page) {
    this.setState({ loading: true, error: null })
    axios.get(this.props.data.mediaRoute, {
      headers: {
        'Accept': 'application/json'
      },
      params: { page, search: this.state.search }
    })
      .then(response => {
        console.log("response", response);
        this.setState({ media: response.data, loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false, error: err.message })
      })
  }

  onFileUploaded(files){
    console.log("uploaded", files);
    const media = this.state.media;

    media.data = [
      ...files.map(f => ({ ...f.serverResponse.payload.data, isNew: true })), 
      ...media.data
    ];
    this.setState({ media })
    
  }

  onPageChange(page){
    this.loadMedia(page);
    this.setState({ currentPage: page });
  }

  handleSubmit(event)  {
    event.preventDefault();

    const term = event.target.search.value;
    this.setState({ search: term }, () => {
      this.loadMedia(1);
    });
  }

  render() {

    const { title , endpoint } = this.props.data;
    const { total, per_page } = this.state.media;

    return (
      <div className="container-fluid">
        <div class="mb-4">
          <form
            onSubmit={this.handleSubmit}
          >
            <div class="row mb-3">
              <div class="col-md-8 mb-2">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text white border-right-0">
                      <i class="fa fa-search"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    name="search"
                    class="form-control border-left-0"
                    title="Search by title"
                  />
                </div>
              </div>
              <div class="col-md-2 mb-2">
                <button
                  class="btn btn-block btn-primary waves-effect waves-light"
                  type="submit"
                >
                  Search
                </button>
              </div>
              <div class="col-md-2 mb-2">
                <a
                  href="https://admin.islandroutes.com/media"
                  class="btn btn-block btn-outline-secondary waves-effect waves-light"
                >
                  <i class="fa fa-undo mr-2"></i>Reset
                </a>
              </div>
            </div>
          </form>
        </div>

        {this.state.loading && (
          <div
            className="overlay position-fixed d-flex justify-content-center align-items-center"
            style={{
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "#ffffff90",
              zIndex: 9,
            }}
          >
            <div class="spinner-border text-dark" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-12">
            <h3>{title}</h3>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-12">
            <MediaUploader
              uploadUrl={endpoint}
              onFileUploaded={this.onFileUploaded}
            />
          </div>
        </div>

        <div>
          <div className="row">
            <div className="col">
              <div className="card mb-3">
                <div className="card-body p-0">
                  <table className="table table-striped mb-0">
                    <thead>
                      <tr>
                        <th>File</th>
                        <th></th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!this.state.loading &&
                        this.state.media.data.map((medium, i) => (
                          <MediumItem
                            key={i}
                            file={medium}
                            router={this.state.router}
                            csrf_token={this.props.data.csrf_token}
                          />
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col">
            <Pagination
              onChange={(page) => this.onPageChange(page)}
              current={this.state.currentPage}
              pageSize={per_page}
              total={total}
            />
          </div>
        </div>
      </div>
    );
  }
}

if (document.getElementById('mediaIndex')) {
    
  const element = document.getElementById('mediaIndex');
  const data = Object.assign({}, element.dataset);
  
  ReactDOM.render(<Media data={JSON.parse(data.data)} />, document.getElementById('mediaIndex'));
}



// WEBPACK FOOTER //
// ./resources/js/components/Media/index.js